var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import $request from '../../utils/request';
import { businessScene as business } from '../../enum/msg-center';
var state = {
    percentage: 0,
    showChangeFileBtn: true,
    changeBtnName: '取消',
    commonBread: {
        prewRouterName: '',
        prewName: '',
        currentName: '',
    },
    commonLoading: null,
    isOpenMsgListModel: false,
    isOpenAnnouncement: false,
    msgList: [],
    msgListTotalItemCount: 0,
    windowMsgList: [],
    noticeMsgList: [],
    unviewNum: 0,
    popData: null,
    popClearTimeout: true,
    popInstanceList: [],
    announcement: {},
    todoListLength: 0,
    isAllSelectMessageList: false,
    isExistSelectMessageListItem: false,
    ishandCheckAll: false,
    checkMessageList: [],
    agreementList: [],
    isTenantCodeListLastFetchId: 0,
    tenantCodeListLoading: false,
    tenantCodeList: [],
    dataCreditAgreementList: [],
};
var mutations = {
    update: function (state, props) {
        for (var key in props) {
            if (state.hasOwnProperty(key)) {
                state[key] = props[key];
            }
        }
    },
};
var actions = {
    // 公共loading
    GET_LOADING: function (_a) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        state.commonLoading = Vue.prototype.$loading({
            spinner: 'el-icon-loading',
            background: 'rgba(300, 300, 300, 0.5)',
            customClass: 'loading',
            body: true,
        });
    },
    // 获取消息列表
    GET_MSGLIST: function (_a, _b) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        var _c = _b === void 0 ? {} : _b, _d = _c.pageNo, pageNo = _d === void 0 ? 1 : _d, _e = _c.pageSize, pageSize = _e === void 0 ? 20 : _e, _f = _c.msgTypeList, msgTypeList = _f === void 0 ? [] : _f, _g = _c.businessSceneList, businessSceneList = _g === void 0 ? [] : _g, _h = _c.viewStatus, viewStatus = _h === void 0 ? '' : _h, _j = _c.position, position = _j === void 0 ? '' : _j;
        $request({
            method: 'post',
            url: '/proxy/api/msg/station/list',
            data: {
                pageNo: pageNo,
                pageSize: pageSize,
                msgTypeList: msgTypeList,
                viewStatus: viewStatus,
                businessSceneList: businessSceneList,
            },
        }).then(function (res) {
            if (!res)
                return;
            if (res.errorCode === 0) {
                var data = res.data, totalItemCount = res.totalItemCount;
                var list = data.map(function (item) {
                    item.isShowRead = false;
                    return item;
                });
                if (position === 'window') {
                    commit('update', {
                        windowMsgList: list,
                    });
                    return;
                }
                if (position === 'notice') {
                    commit('update', {
                        noticeMsgList: list,
                    });
                    return;
                }
                commit('update', {
                    msgList: list,
                    msgListTotalItemCount: totalItemCount,
                });
            }
        });
    },
    // 将消息标记成已读
    TAG_READSTATUS: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        $request({
            method: 'post',
            url: '/proxy/api/msg/station/viewed',
            data: {
                msgList: params.msgList,
            },
        }).then(function (res) {
            if (!res)
                return;
            if (res.errorCode === 0) {
                if (params.type !== 'stop') {
                    new Vue().$message({
                        type: 'success',
                        message: '操作成功!',
                    });
                }
                params.callback && params.callback();
            }
        });
    },
    // 获得未读消息数量
    GET_UNVIEWCOUNT: function (_a) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        $request({
            method: 'post',
            url: '/proxy/api/msg/station/unview/count',
        }).then(function (res) {
            if (!res)
                return;
            if (res.errorCode === 0) {
                commit('update', {
                    unviewNum: res.data,
                });
            }
        });
    },
    // 获取弹屏消息
    GET_POPDATA: function (_a, params) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        $request({
            method: 'post',
            url: '/proxy/api/msg/station/popup',
            loadingControl: 'hand',
        }).then(function (res) {
            if (!res)
                return;
            if (res.errorCode === 0) {
                commit('update', {
                    popData: res.data,
                });
                params.callback && params.callback();
                return;
            }
        });
    },
    // 消息跳转到对应落地页
    TOLANDDINGPAGE: function (_a, _b) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        var _c = _b.data, data = _c === void 0 ? {} : _c, _d = _b.this_, this_ = _d === void 0 ? new Vue() : _d;
        var businessScene = data.businessScene;
        if (businessScene === 'SYS_NOTICE') {
            return commit('update', {
                isOpenAnnouncement: true,
                announcement: data,
            });
        }
        var routeArr = business[businessScene].split('?');
        var paramsArr = routeArr.length > 1 ? routeArr[1].split('&') : [];
        var params = {};
        if (paramsArr.length > 0) {
            paramsArr.forEach(function (item) {
                var itemArr = item.split('=');
                params[itemArr[0]] = itemArr[1];
            });
        }
        this_.$router.push({ name: routeArr[0], params: params });
    },
    // 更新消息状态
    UPDATESTATUS: function (_a) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        dispatch('GET_MSGLIST', {
            pageNo: 1,
            pageSize: 1000,
            viewStatus: 'NO_VIEW',
            position: 'window',
        }); // 更新未读列表
        dispatch('GET_UNVIEWCOUNT'); // 更新未读消息数量
        dispatch('GET_MSGLIST', {
            viewStatus: 'NO_VIEW',
        }); // 更新站内信
    },
    // 获取banner配置
    GET_BANNER: function (_a, _b) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        var bannerType = _b.bannerType, _c = _b.cityId, cityId = _c === void 0 ? '' : _c, _d = _b.channelId, channelId = _d === void 0 ? '' : _d, callback = _b.callback;
        $request({
            url: "/proxy/marketingmis/banners?bannerType=" + bannerType + "&cityId=" + cityId + "&channelId=" + channelId,
            method: 'get',
        }).then(function (res) {
            var data = null;
            if (res.errorCode === 0 && res.data && res.data.galleries && res.data.galleries.length > 0) {
                data = res.data.galleries;
            }
            callback && callback(data);
        });
    },
    // 获取待签署协议列表
    GET_UNSIGNLIST: function (_a) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        $request({
            url: '/proxy/fund-api/capital/contract/list/sign/not',
            method: 'post',
            isShowNoLimit: false,
        }).then(function (res) {
            if (!res || res.errorCode !== 0) {
                return;
            }
            var data = res.data;
            commit('update', {
                agreementList: data || [],
            });
        });
    },
    // 获取数据授权协议列表
    GET_DATA_CREDIT_LIST: function (_a) {
        var state = _a.state, commit = _a.commit, dispatch = _a.dispatch;
        console.log(1244);
        $request({
            url: '/proxy/api/capital/getPopUpLicenseAgreement',
            method: 'post',
            isShowNoLimit: false,
        }).then(function (res) {
            if (!res || res.errorCode !== 0) {
                return;
            }
            var data = res.data;
            commit('update', {
                dataCreditAgreementList: data || [],
            });
        });
    },
    // 查询资方/cp公司
    GET_TENANT_CODE: function (_a, param) {
        var commit = _a.commit;
        if (param === void 0) { param = {}; }
        commit('update', {
            isTenantCodeListLastFetchId: state.isTenantCodeListLastFetchId++,
            tenantCodeList: [],
            tenantCodeListLoading: true,
        });
        var fecthId = state.isTenantCodeListLastFetchId;
        $request({
            method: 'POST',
            url: '/proxy/fund-api/capital/contract/cp/tenant',
            data: __assign({}, param),
            loadingControl: 'hand',
        }).then(function (res) {
            if (state.isTenantCodeListLastFetchId !== fecthId) {
                return;
            }
            if (!res) {
                commit('update', {
                    tenantCodeListLoading: false,
                    isTenantCodeListLastFetchId: 0,
                });
                return;
            }
            if (res.errorCode === 0) {
                var data = res.data || [];
                var list = data.map(function (item) {
                    item.value = item.tenantCode;
                    item.label = item.name;
                    return item;
                });
                commit('update', {
                    tenantCodeList: list,
                    tenantCodeListLoading: false,
                    isTenantCodeListLastFetchId: 0,
                });
            }
        });
    },
};
export default {
    namespaced: true,
    state: state,
    mutations: mutations,
    actions: actions,
};
